;(function () {
  angular
    .module('contrast.tsv.onboard')
    .controller('TsvSetupCtrl', TsvSetupCtrl)

  function TsvSetupCtrl(
    $uibModal,
    $document,
    $location,
    permissions,
    UserService,
    tsvApiConfig
  ) {
    'ngInject'

    function init() {
      if (UserService.getCurrentOrganization() == null) {
        permissions.getDefaultOrganization().then(getOnboardSettings)
      } else {
        getOnboardSettings()
      }
    }

    function getOnboardSettings() {
      tsvApiConfig.getOnboardSettings().then(function (response) {
        if (response.data.show) {
          openTsvModal()
        } else {
          $location.path(UserService.buildUrl('/dashboard'))
        }
      }, openTsvModal)
    }

    function openTsvModal() {
      $uibModal.open({
        templateUrl: 'views/tsv/onboard.html',
        controller: 'TsvModalCtrl',
        windowClass: 'tsv-setup-dialog',
        appendTo: $document.find('aside'),
        backdrop: false,
        keyboard: false,
        resolve: {
          isTsvMandatory: UserService.getTsvRequired()
        }
      })
    }

    init()
  }
})()
